const ITEMS = [
  "140M+ VERIFIED CONTACTS",
  "GDPR · CCPA · CASL COMPLIANT",
  "90+ GLOBAL MARKETS",
  "TRIPLE-TOUCH VERIFICATION",
  "15,000+ INSTALL BASES TRACKED",
  "99.4% ALLOCATION FULFILLMENT",
  "100% OPT-IN VERIFIED",
  "650K+ LEADS DELIVERED ANNUALLY",
];

export const Marquee = ({ dark = true }) => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      className={`marquee-paused relative overflow-hidden border-y py-5 ${
        dark ? "border-white/10 bg-eblue" : "border-line bg-white"
      }`}
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-jakarta text-sm font-bold tracking-[0.18em] ${
                dark ? "text-white/80" : "text-navy/70"
              }`}
            >
              {item}
            </span>
            <span className={`mx-8 text-xs ${dark ? "text-flame" : "text-cobalt"}`}>◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
